export default __webpack_public_path__ + "static/media/avatar_dragon4.8dc1d6e0.mp3";